// import React from 'react';
// import ReactDOM from 'react-dom';

// import App from './App';

// ReactDOM.createRoot(<App />, document.getElementById('root'));

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
